// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1UL0R","colCheckbox":"styles_colCheckbox__272B1"};